var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import _objectWithoutProperties from "/Users/natebosscher1/Sites/terrain-group/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["filter"];
import { SubAPI } from "./SubAPI";
var FormSubmissionAPI = /** @class */ (function (_super) {
    __extends(FormSubmissionAPI, _super);
    function FormSubmissionAPI() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormSubmissionAPI.prototype.listForms = function () { return this.fetcher.get('/api/forms/submission/configs'); };
    FormSubmissionAPI.prototype.getForm = function (input) { return this.fetcher.get('/api/form/submission/config', input); };
    FormSubmissionAPI.prototype.upsertSubmission = function (input) { return this.fetcher.post("/api/form/submission/upsert", input); };
    FormSubmissionAPI.prototype.downloadBulk = function (input) { return this.fetcher.post("/api/form/submissions/for-bulk-download", input); };
    FormSubmissionAPI.prototype.analyzeSubmissions = function (input) {
        var filter = input.filter, props = _objectWithoutProperties(input, _excluded);
        var search = new URLSearchParams();
        for (var k in props) { // @ts-ignore
            var value = props[k];
            if (typeof value !== "undefined") {
                search.set(k, value.toString());
            }
        }
        return this.fetcher.post("/api/form/submissions/for-analyze?" + search.toString(), { filter: filter });
    };
    FormSubmissionAPI.prototype.bulkArchive = function (input) { return this.fetcher.post("/api/form/submission/bulk-archive", input); };
    FormSubmissionAPI.prototype.getSubmission = function (input) { return this.fetcher.get("/api/form/submission", input); };
    FormSubmissionAPI.prototype.uploadFile = function (input) { return this.fetcher.postFormData("/api/form/submission/upload", { submission: JSON.stringify({ submission: input.submission }), file: input.file }); };
    FormSubmissionAPI.prototype.listSubmissions = function (input, filter) {
        if (filter) { // @ts-ignore
            input.forKeyFilter = JSON.stringify(filter);
        }
        return this.fetcher.get("/api/form/submissions", input);
    };
    FormSubmissionAPI.prototype.signAndSubmit = function (input) { return this.fetcher.post("/api/form/submission/sign-and-submit", input); };
    FormSubmissionAPI.prototype.uploadSignature = function (input) { return this.fetcher.postFormData("/api/form/signature", input); };
    FormSubmissionAPI.prototype.submissionCsvDownload = function (id) { return "/api/form/submission/csv?id=".concat(id); };
    FormSubmissionAPI.prototype.getSignatureUrl = function (id, opts) { var params = new URLSearchParams(); params.set("id", id.toString()); if (opts !== null && opts !== void 0 && opts.redirect)
        params.set("redirect", opts.redirect); return "/api/form/signature/view?" + params.toString(); };
    FormSubmissionAPI.prototype.signaturePublicUrl = function (id) { return this.fetcher.get("/api/form/signature/view", { id: id, format: "json-url" }); };
    FormSubmissionAPI.prototype.listApprovals = function (input) { return this.fetcher.get("/api/form/submission/approvals", input); };
    FormSubmissionAPI.prototype.upsertApproval = function (input) { return this.fetcher.post("/api/form/submission/approval", input); };
    FormSubmissionAPI.prototype.upsertTask = function (input) { return this.fetcher.post("/api/form/submission/task", input); };
    return FormSubmissionAPI;
}(SubAPI));
export { FormSubmissionAPI };
